<template>
  <div>
    <a-modal
      :class="{ 'dark-theme-modal': darkTheme }"
      width="700px"
      v-model="modalVisible">
      <template slot="footer">
        <a-button key="submit" @click="handleCloseModal" :ghost="darkTheme ? true : null">Ok</a-button>
      </template>
      <a-row type="flex">
        <a-col :span="24">
          <h2 class="text-center about-title">À propos</h2>
        </a-col>
      </a-row>
      <a-row type="flex">
        <a-col :span="24">
          <p class="about-text">
            Bienvenue dans le journal de travail ! Cette application a été créée dans le cadre du TPI 2019 de <a class="dany-link" href="https://danydc.ch" target="_blank">Dany Oliveira da Costa</a>.
            <br>
            <br>
            Pour consulter le mode d'emploi, utilisez les liens ci-dessous :
            <br>
            <br>
            - <a href="https://jt-dev.s2.rpn.ch/doc/v2_mode_emploi_eleve.pdf" target="_blank">Mode d'emploi élève</a>
            <br>
            - <a href="https://jt-dev.s2.rpn.ch/doc/v2_mode_emploi_enseignant.pdf" target="_blank">Mode d'emploi enseignant</a>
            <br>
            <br>
            Pour rapporter un bug ou proposer des nouvelles fonctionnalités, ouvrir une issue sur le dépôt de l'application :
            <br>
            <br>
            - <a href="https://git.s2.rpn.ch/journal-de-travail/app/issues" target="_blank">Dépôt de l'application</a>
            <br>
            <br>
            Responsable d'exploitation : <a href="mailto:daniel.rebetez@rpn.ch">D. Rebetez</a>
          </p>
        </a-col>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'AboutModal',
  methods: {
    moment,
    ...mapActions({
      'setSelectedWork': 'work/setSelectedWork',
      'toggleAboutModalVisible': 'modal/toggleAboutModalVisible'
    }),
    handleCloseModal () {
      this.modalVisible = 'default'
    }
  },
  computed: {
    // v-model va automatiquement essayer de set printModalVisible lors de la fermeture de la modale. On crée donc
    // une computed property en lui indiquant quelle state il doit modifier suivant le type de la modale
    modalVisible: {
      get () {
        return this.aboutModalVisible
      },
      set (value) {
        this.toggleAboutModalVisible()
      }
    },
    ...mapState({
      darkTheme: state => state.darkTheme,
      selectedWork: state => state.work.selectedWork,
      user: state => state.auth.user,
      aboutModalVisible: state => state.modal.aboutModalVisible
    })
  }
}
</script>

<style scoped lang="scss">
.dany-link{
  text-decoration: underline;
  color: inherit;
}
.about-title{
  margin-bottom: 20px;
}
.about-text{
  text-align: justify;
  font-size: 15px;
}
</style>
